export function isNumber(value: unknown): value is number {
    return typeof value === "number" && !Number.isNaN(value);
}

export function isString(value: unknown): value is string {
    return typeof value === "string";
}

export function isBoolean(value: unknown): value is boolean {
    return typeof value === "boolean";
}

export function isFunction(value: unknown): value is (...args: any[]) => any {
    return typeof value === "function";
}

export function isObject(value: unknown): value is object {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function isPlainObject(
    value: unknown,
): value is Record<string, unknown> {
    if (typeof value !== "object" || value === null) {
        return false;
    }
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}

export function isEnumMember<T extends string>(enumObject: Record<string, T>) {
    return (value: string): value is T =>
        Object.values(enumObject).some((member) => member === value);
}

export function isOneOf<T extends string>(values: readonly T[]) {
    return (value: string): value is T =>
        values.some((member) => member === value);
}
